<script setup lang="ts">
import Link from '@/components/Link.vue';
import type { DetailedAssignee } from '@/types/assignee';
import { defineProps } from 'vue';
defineProps<{
    detailedAssignee: DetailedAssignee;
}>();
</script>

<template>
    <Link
        v-if="detailedAssignee.type == 'Team' && detailedAssignee._id"
        :route-to="{ name: 'team', params: { id: detailedAssignee._id } }"
        icon="group"
        :displayText="detailedAssignee.name"
    />
    <Link
        v-else-if="detailedAssignee.type == 'Employee' && detailedAssignee._id"
        :route-to="{ name: 'employee', params: { id: detailedAssignee._id } }"
        icon="person"
        :displayText="detailedAssignee.name"
    />
    <div v-else class="d-flex align-center ga-1">
        <v-icon icon="warning" class="text-red" />
        <span>Geen</span>
    </div>
</template>
